import { type RootState } from "features/Application/store/store";

export const getHistoryResults = (state: RootState) => state.account.history;
export const selectHistory = (state: RootState) => state.account.history.search;
export const selectHistoryFilters = (state: RootState) => state.account.history.search.appliedFilters;
export const selectHistoryResults = (state: RootState) => state.account.history.items;
export const selectHistorySortType = (state: RootState) => state.account.history.search.sortType;
export const selectHistoryResultsStatus = (state: RootState) => state.account.history.status;
export const selectHistoryResultsError = (state: RootState) => state.account.history.errorMessage;
export const selectHistoryResultsActivePage = (state: RootState) => state.account.history.activePage;
export const selectHistoryResultsReachedEnd = (state: RootState) => state.account.history.reachedEnd;
export const selectFilterOptions = (state: RootState) => state.account.history.filterOptions;
